export default __webpack_public_path__ + "static/media/Tanya_Karn_Content_creation_lead.3599c509.jpg";